module.exports = __webpack_public_path__ + "static/media/PDF_LT_2.d2265349.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/PDF_LT_2.pdf
// module id = 675
// module chunks = 0